export default (message: string) => {
  const replyRegex = /&#8618;\s"(.*?)"\n\n((.|\s)*)/gi;
  const replyAndMessageMatch = Array.from(message.matchAll(replyRegex));

  return replyAndMessageMatch.length && replyAndMessageMatch[0].length
    ? {
      message: replyAndMessageMatch[0][2].toString(),
      reply: replyAndMessageMatch[0][1].toString(),
    }
    : {
      message: message,
    };
};
